import { render, staticRenderFns } from "./block-advantages.vue?vue&type=template&id=3b0a7b45&scoped=true&"
import script from "./block-advantages.vue?vue&type=script&lang=js&"
export * from "./block-advantages.vue?vue&type=script&lang=js&"
import style0 from "./block-advantages.vue?vue&type=style&index=0&id=3b0a7b45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a7b45",
  null
  
)

export default component.exports